module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"caris-select":{"loading":"Laden"}}}')
  delete Component.options._Ctor
}
